import React, { useEffect, useState } from 'react'
import { Button, Modal } from 'semantic-ui-react'

import TeamMemberMappingInput from 'components/TeamMemberMappingInput'

/**
 *
 * @param {object} props
 * @param {() => void} props.close
 * @param {object} props.user
 * @param {string[]} props.teamMemberMapping
 * @param {(teamMemberMapping: string[]) => void} props.onEditTeamMemberMapping
 * @param {boolean} props.isSaveButtonLoading
 * @param {Array<{email: string, name: string}>} props.teamMembers
 * @param {boolean} props.isTeamMembersLoading
 */
export default function TeamMemberMappingModalContent({
  close,
  user,
  teamMemberMapping,
  onEditTeamMemberMapping,
  isSaveButtonLoading,
  teamMembers,
  isTeamMembersLoading,
}) {
  const [teamMemberMappingState, setTeamMemberMappingState] = useState(teamMemberMapping)
  useEffect(() => {
    setTeamMemberMappingState(teamMemberMapping)
  }, [teamMemberMapping])

  function handleEditTeamMemberMapping() {
    onEditTeamMemberMapping(teamMemberMappingState)
  }

  function handleTeamMemberMappingChange(teamMemberMapping) {
    setTeamMemberMappingState(teamMemberMapping)
  }

  return (
    <React.Fragment>
      <Modal.Header>Team member mapping</Modal.Header>
      <Modal.Content>
        <p>
          Map users to team members to enable more granular feedback visibility and notification
          controls.
        </p>
        <p>
          <a
            href="https://help.simplesat.io/en/articles/15052163-team-members"
            target="_blank"
            rel="noreferrer"
          >
            <i className="icon far fa-book" />
            Learn more about team member mapping
          </a>
        </p>
        <TeamMemberMappingInput
          loading={!teamMemberMapping || isTeamMembersLoading}
          fixedTeamMemberMapping={user.email}
          defaultTeamMemberMapping={teamMemberMapping}
          onTeamMemberMappingChange={handleTeamMemberMappingChange}
          teamMembers={teamMembers}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={close}>Cancel</Button>
        <Button
          primary
          onClick={handleEditTeamMemberMapping}
          loading={isSaveButtonLoading}
          disabled={isSaveButtonLoading}
        >
          Save
        </Button>
      </Modal.Actions>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/TeamMemberMappingModalContent/index.js